import React, { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import Icon from '@ifit/react-icons/dist/components/icon';
import LOCKED_SOLID from '@ifit/react-icons/dist/icons/LOCKED_SOLID';
import { white } from '@ifit/base-coat/js/colors';

export type Props = {
  children: ReactNode;
  style?: Object;
  live?: boolean;
  recommended?: boolean;
  locked?: boolean;
};

const Chip: React.FC<Props> = ({ live, recommended, locked, style, children }: Props) => {
  return (
    <p className={classnames(styles.chip, 'chip',
      { [styles.live]: live, 'live': live },
      { [styles.recommended]: recommended, 'recommended': recommended },
      { [styles.locked]: locked, 'locked': locked })} style={style}>
      {children}
      {locked && recommended && (
        <Icon
          icon={LOCKED_SOLID}
          color={white}
          size={17}
          className={styles['mp-chip-locked-icon']}
        />
      )}
    </p>
  );
};

export default Chip;
